import capitalizedName from '$utils/capitalizedName';
import { ErrorMessageEn } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  SearchCandidateInput,
  SearchCandidateOutput,
} from '../candidates.types';

export const searchCandidate = (builder: CandidateBuilder) =>
  builder.query<SearchCandidateOutput, SearchCandidateInput>({
    query: ({
      Keyword,
      Type,
      Files,
      page,
      take,
      QualityStatus,
      Country,
      CountryGroup,
      Salary,
      OpenToWork,
      orderBy,
      Order,
    }) => {
      const filesFilter = ['Video', 'CV', 'Reference'];

      const params = new URLSearchParams();
      params.set('Keyword', Keyword);
      params.set('Type', Type || 'Everything');
      params.set('page', `${page}`);
      params.set('take', `${take}`);
      params.set('orderBy', `${orderBy}`);
      params.set('order', `${Order}`);

      filesFilter.forEach((singleFileFilter) => {
        if (Files?.toLowerCase()?.includes(singleFileFilter.toLowerCase())) {
          params.set(singleFileFilter, 'true');
        }
      });

      if (Salary) {
        try {
          const parsedSalary = parseInt(Salary, 10);
          params.append('SalaryUpperBound', `${parsedSalary}`);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }

      if (QualityStatus) {
        QualityStatus.split(',').forEach((singleQualityStatus) => {
          params.append('QualityStatus', singleQualityStatus);
        });
      }

      if (Country) {
        Country.forEach((singleCountry) => {
          params.append('Country', singleCountry);
        });
      }

      if (CountryGroup) {
        CountryGroup.forEach((singleCountryGroup) => {
          const formattedCountryGroupName = singleCountryGroup.toLowerCase();
          let backendCountryGroupName = '';

          if (formattedCountryGroupName === 'other') {
            backendCountryGroupName = 'Rest of the world';
          } else {
            backendCountryGroupName = capitalizedName(singleCountryGroup);
          }

          params.append('CountryGroup', backendCountryGroupName);
        });
      }

      if (OpenToWork) {
        OpenToWork.split(',').forEach((singleOpenToWork) => {
          params.append('OpenToWork', singleOpenToWork);
        });
      }

      return {
        url: `/candidates/search?${params.toString()}`,
        method: 'GET',
      };
    },
    transformErrorResponse: (error) => {
      if (error.status === 400) {
        errorHandler(
          '[getCandidatesSearch]',
          'Your search matched too many candidates. Please add additional filters to narrow down your results.',
          error.data,
          true
        );
      } else {
        errorHandler(
          '[getCandidatesSearch]',
          ErrorMessageEn.GetCandidatesFail,
          error.data,
          true
        );
      }
      return error.data;
    },
  });
